import './index.css';
import { useState } from 'react';

interface YouTubeSearchProps {
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  searchYouTube: (query: string) => void;
  clearSearch: () => void;
  clearMessage: () => void;
  videos: Array<{ url: string; title: string; thumbnail: string }>;
  loading: boolean;
  error: string | null;
  addVideo: (video: { url: string; title: string; thumbnail: string }) => void;
}

const decodeHtml = (html: string) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

const YouTubeSearch = ({
  searchQuery,
  setSearchQuery,
  searchYouTube,
  clearSearch,
  clearMessage,
  videos,
  loading,
  error,
  addVideo,
}: YouTubeSearchProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={`youtube-search-container ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <div className='search-header' onClick={() => setIsExpanded(!isExpanded)}>
        <h2>Search YouTube</h2>
        <span className='toggle-icon'>{isExpanded ? '−' : '+'}</span>
      </div>

      {isExpanded && (
        <>
          <div className='search-controls'>
            <div className='search-input-group'>
              <input
                type='text'
                placeholder='Search for a video...'
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                className='search-input'
                onKeyDown={e => e.key === 'Enter' && searchYouTube(searchQuery)}
              />
              <div className='button-group'>
                <button
                  type='button'
                  onClick={() => searchYouTube(searchQuery)}
                  className='search-button'
                  disabled={!searchQuery.trim()}>
                  Search
                </button>
                <button
                  type='button'
                  onClick={() => {
                    clearSearch();
                    setSearchQuery('');
                    clearMessage();
                  }}
                  className='clear-button'
                  disabled={!searchQuery.trim() && videos.length === 0}>
                  Clear
                </button>
              </div>
            </div>
          </div>

          <div className='search-results'>
            {loading && <div className='loading-spinner'>Loading...</div>}
            {error && <p className='error-message'>{error}</p>}

            {videos.length > 0 && (
              <>
                <h3>Results</h3>
                <ul className='video-list'>
                  {videos.map(video => (
                    <li key={video.url} className='video-item'>
                      <img src={video.thumbnail} alt={video.title} className='video-thumbnail' />
                      <div className='video-info'>
                        <p>{decodeHtml(video.title)}</p>
                      </div>
                      <button type='button' onClick={() => addVideo(video)} className='add-button'>
                        Add to Queue
                      </button>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default YouTubeSearch;
